import {ApiAction} from 'redux-upgrader';

export const GET_TAGS = new ApiAction('GET_TAGS');
export const GET_TAG = new ApiAction('GET_TAG');
export const GET_ENTITY_TAG = new ApiAction('GET_ENTITY_TAG');
export const GET_ENTITY_FILTERED_TAG = new ApiAction('GET_ENTITY_FILTERED_TAG');
export const SET_LIST_VIEW_TYPE_LANDING = 'SET_LIST_VIEW_TYPE_LANDING';
export const FOLLOW_TAG = new ApiAction('FOLLOW_TAG');
export const UNFOLLOW_TAG = new ApiAction('UNFOLLOW_TAG');
